<template>
  <div class="mp-header-desktop">
    <div class="header-item">
      <span @click="onProfileClick" class="user-name-container">
        <b-icon
          icon-pack="fa"
          icon="user-circle"
          size="is-large"
          class="user-profile"
        ></b-icon>
        <div class="is-hidden-touch user-name">{{ displayName }}</div>
      </span>
    </div>
    <div class="header-item">
      <b-dropdown v-if="countries" v-model="selectedCountryId" position="is-bottom-left" :mobile-modal="false" aria-role="list">
        <template v-if="selectedCountry" #trigger="{ active }">
          <button class="button is-small" outlined>
            <span v-html="getFlag(selectedCountry.flag)" class="flag"></span>
            <span>{{ selectedCountry.languageIso.split("-")[0] }}</span>
            <!-- <span>{{ selectedCountry.languageIso }}</span> -->
            <b-icon icon-pack="fa" :icon="active ? 'chevron-up' : 'chevron-down'" size="is-small"></b-icon>
          </button>
        </template>
  
        <b-dropdown-item v-for="country in countries" :key="country.id" :value="country.id" aria-role="listitem">
          <div class="country-list-item">
            <div v-html="getFlag(country.flag)" class="flag"></div>
            <div>{{ country.languageName }}</div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import twemoji from "@twemoji/api";
import { mapMutations } from "vuex/dist/vuex.common.js";

export default {
  name: "LoggedInHeader",
  data() {
    return {
      selectedCountryId: null,
    }
  },
  methods: {
    ...mapMutations({
      setCountryById: "i18n/setCountryById",
    }),
    onProfileClick() {
      this.$router.push({
        name: "Profile",
      });
    },
    getFlag(flag) {
      if (flag) {
        return twemoji.parse(flag, {
          folder: "svg",
          ext: ".svg",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      displayName: "session/displayName",
      countries: "i18n/countries",
      selectedCountry: "i18n/country",
    }),
  },
  watch: {
    selectedCountryId: {
      handler(newValue) {
        this.setCountryById(newValue);
      },
      // immediate: true,
    },
    selectedCountry: {
      handler(newValue) {
        this.selectedCountryId = newValue?.id;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.mp-header-desktop {
  display: none;
  // flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  background-color: $white;
  z-index: 1;
  height: 3.5rem;
  padding: 4px 32px;
  gap: 32px;

  .header-item {
    display: flex;
    gap: 1rem;

    .user-name-container {
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;

      // .user-name {
      //   margin-top: 4px;
      // }
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      height: 24px;
      padding: 0;
      background: none;
      border: none;
      gap: 5px;
      z-index: 1;

      &:focus {
        outline: none;
        box-shadow: none;
      }

      span {
        width: 18px;
      }

      .icon {
        margin: 0;
        width: 18px;
        height: 18px;

        svg {
          width: 10px;
          height: 10px;
        }
      }

      .flag {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
    }
  }
}

.country-list-item {
  display: flex;
  gap: 0.5rem;
  height: 24px;

  .flag {
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 24px;
  }
}

@media only screen and (min-width: 769px) {
  .mp-header-desktop {
    display: flex;
  }
}
</style>
